import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tog-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/loader/loader.component.ts